import * as React from "react";
import { DropzoneOptions, useDropzone } from "react-dropzone";
import LoadingWithMessage, { FontSize } from "./components/LoadingWithMessage";
import "./DragDrop.scss";

export interface DragDropProps {
    id: string;
    options: DropzoneOptions;
    isUploading?: boolean;
    isError?: boolean;
}

export const DragDrop = ({ id, options, isUploading = false, isError = false }: DragDropProps) => {
    const { getRootProps, getInputProps, isDragAccept, isDragActive, isDragReject, isFocused } = useDropzone(options);

    const baseStyle = {
        flex: 1,
        display: 'flex',
        flexDirection: 'column' as 'column',
        alignItems: 'center',
        padding: '20px',
        borderWidth: 2,
        borderRadius: 2,
        borderColor: '#eeeeee',
        borderStyle: 'dashed',
        backgroundColor: '#fafafa',
        color: '#bdbdbd',
        outline: 'none',
        transition: 'border .24s ease-in-out'
    };

    const focusedStyle = {
        borderColor: '#2196f3'
    };

    const activeStyle = {
        borderColor: '#2196f3'
    };

    const acceptStyle = {
        borderColor: '#00e676'
    };

    const rejectStyle = {
        borderColor: '#ff1744'
    };

    const errorStyle = {
        borderColor: '#ca0511',
        borderStyle: 'solid',
        borderWidth: '1px',
        borderRadius: '4px'
    }

    const uploadingStyle = {
        border: 'none'
    }

    const style = React.useMemo(() => ({
        ...baseStyle,
        ...(isFocused ? focusedStyle : {}),
        ...(isDragActive ? activeStyle : {}),
        ...(isDragAccept ? acceptStyle : {}),
        ...(isDragReject ? rejectStyle : {}),
        ...(isUploading ? uploadingStyle : {}),
        ...(isError ? errorStyle : {})
    }), [
        isFocused,
        isDragActive,
        isDragReject,
        isDragAccept,
        isUploading,
        isError
    ]);

    return (
        <>
            <div className={isUploading ? "active-animation" : ""} {...getRootProps({ style })}>
                <input id={id} {...getInputProps()} />

                {isUploading ? <LoadingWithMessage size={FontSize.OneX} message="Uploading..." /> : <p>{`Drop file${options.multiple ? 's' : ''} here or click to attach for upload.`}</p>}
            </div>
            {isError ? <span data-automationid="ValidationError" className="field-validation-error">Field is Required</span> : null}
        </>
    );
}
